import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { TopBar } from '../../components/TopBar';

import MapButtonPdfFr from '../../images/pdf/Jeu_Parcours_cimetiere_Neder_plan_fr.pdf';
import MapButtonPdfNl from '../../images/pdf/Jeu_Parcours_cimetiere_Neder_plan_nl.pdf';

import './index.scss';

type Props = {
    baseUrl?: string;
};

export const Welcome: FunctionComponent<Props> = ({ baseUrl = '' }) => {
    const { t } = useTranslation();
    const { language } = useParams();

    return (
        <>
            <TopBar baseUrl={baseUrl} />
            <section className={`${language} container welcome with-top-bar`}>
                <div className="content">
                    <h1>
                        <p>{t('welcome.title')}</p>
                    </h1>

                    <div className="welcome-text">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: t('welcome.text'),
                            }}
                        />
                    </div>

                    <a
                        href={
                            language === 'fr' ? MapButtonPdfFr : MapButtonPdfNl
                        }
                        className="map-button"
                        aria-label={t('welcome.button')}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {' '}
                    </a>
                    <div className="background" />
                </div>
                <div className="history">
                    <h1 className="history-title">
                        <p>{t('welcome.history_title')}</p>
                    </h1>

                    <div className="history-text">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: t('welcome.history_content'),
                            }}
                        />
                    </div>
                </div>
                <div
                    className="content bottom-button"
                    style={{ marginBottom: '10vw' }}
                >
                    <a
                        className="button go"
                        href={`/${baseUrl}/${language}/1/easy/step_1`}
                        aria-label={t('map.next')}
                    >
                        {' '}
                    </a>
                </div>
            </section>
        </>
    );
};
